import { render, staticRenderFns } from "./tween.vue?vue&type=template&id=2caffe90&"
import script from "./tween.vue?vue&type=script&lang=js&"
export * from "./tween.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports